/*
 * Module for the New Benefits Estimate page
*/
rs.module("ui/content/benefits/estimates/new",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors, separationTypes, backendUrls) {

            // Unpack Js Selectors
            var fundPicker = $.js(jsSelectors.fundPicker, { required: false });
            var newEstimateForm = $.js(jsSelectors.newEstimateForm);
            var separationTypeSelect = newEstimateForm.js(jsSelectors.separationTypeSelect);
            var separationDate = newEstimateForm.js(jsSelectors.separationDate);
            var separationDateHidden = newEstimateForm.js(jsSelectors.separationDateHidden);
            var benefitEffectiveDate = newEstimateForm.js(jsSelectors.benefitEffectiveDate);
            var benefitEffectiveDateHidden = newEstimateForm.js(jsSelectors.benefitEffectiveDateHidden);
            var separationSubTypeSelect = newEstimateForm.js(jsSelectors.separationSubTypeSelect);
            var backDropCheckbox = newEstimateForm.js(jsSelectors.backDropCheckbox);
            var backDropDate = newEstimateForm.js(jsSelectors.backDropDate);
            var backDropMonths = newEstimateForm.js(jsSelectors.backDropMonths);
            var retirementDetailsSection = newEstimateForm.js(jsSelectors.retirementDetailsSection);
            var dropPlanSection = newEstimateForm.js(jsSelectors.dropPlanSection);
            var dropPlanSelect = newEstimateForm.js(jsSelectors.dropPlanSelect);
            var dropEntryDate = newEstimateForm.js(jsSelectors.dropEntryDate);
            var backDropSection = newEstimateForm.js(jsSelectors.backDropSection);
            var backDropSectionDetails = newEstimateForm.js(jsSelectors.backDropSectionDetails);
            var fundKey = newEstimateForm.js(jsSelectors.fundKey);
            var loadingSpinner = $.js(jsSelectors.loadingSpinner);
            var beneficiaryCheckbox = $.js(jsSelectors.beneficiaryCheckbox);
            var beneficiarySection = $.js(jsSelectors.beneficiarySection);
            var salaryChangeCheckbox = $.js(jsSelectors.salaryChangeCheckbox);
            var salaryChangeSection = $.js(jsSelectors.salaryChangeSection);
            var purchaseEstimatesSwitch = $.js(jsSelectors.purchaseEstimatesSwitch);
            var purchaseEstimatesSection = $.js(jsSelectors.purchaseEstimatesSection);
            var purchaseEstimatesSectionDetails = $.js(jsSelectors.purchaseEstimatesSectionDetails);
            var selectedPurchaseEstimateCheckbox = $.js(jsSelectors.selectedPurchaseEstimateCheckbox, { required: false, multiple: true });
            var selectedPurchaseEstimateRetirementDate = $.js(jsSelectors.selectedPurchaseEstimateRetirementDate, { required: false, multiple: true });
            var selectedPurchaseEstimateAnnuityDate = $.js(jsSelectors.selectedPurchaseEstimateAnnuityDate, { required: false, multiple: true });
            var salaryIncreaseContainer = $.js(jsSelectors.salaryIncreaseContainer);
            var salaryIncreaseTemplate = $.js(jsSelectors.salaryIncreaseTemplate);
            var addSalaryIncrease = $.js(jsSelectors.addSalaryIncrease);

            // The fields available on the form depend on which separation type is selected
            separationTypeSelect.change(function () {
                separationSubTypeSelect.toggle($(this).val() == separationTypes.disability);
                dropPlanSection.toggle($(this).val() == separationTypes.drop);
                retirementDetailsSection.toggle($(this).val() != separationTypes.drop);
                purchaseEstimatesSection.toggle($(this).val() != separationTypes.drop);

                // These checkboxes might not be on screen at all
                // Conditionally disable them to avoid mistakenly posting
                backDropCheckbox.setDisabled($(this).val() != separationTypes.retirement)
                purchaseEstimatesSwitch.setDisabled($(this).val() == separationTypes.drop)

                // Toggle BackDROP visibility
                if ($(this).val() == separationTypes.retirement) {
                    _toggleBackDROPVisibility();
                }
                else {
                    backDropSection.toggle(false);
                }
            });

            // On the rare occasion the user has more than one relevant fund, we'll start the process over if they change funds
            fundPicker.change(function () {
                window.location.href = `${backendUrls.newEstimate}?fundKey=${fundPicker.val()}`;
            });

            // Show a loading spinner and "disable" fields when we submit
            newEstimateForm.submit(function (e) {

                // Clear event banner messages
                eventBanner.removeAllMessages();

                // Validate form before showing spinner and hiding fields
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    loadingSpinner.show();

                    // Prevent further interaction with the form
                    newEstimateForm.css("pointer-events", "none")
                    // Bootstrap's custom control toggles don't respond to pointer events, so manually unhook them
                    newEstimateForm.find(".custom-control-label").removeAttr("for")
                }
                else {
                    e.preventDefault();
                }
            })

            // When we change the separation date, we may need to update the Benefit Effective Date and BackDrop Date
            separationDate.change(_handleSeparationDateChange);

            // Show the BackDrop section if BackDrop is checked
            backDropCheckbox.change(function () {
                backDropSectionDetails.toggle($(this).val());
            });

            // Show the beneficiary info if include beneficiary is checked
            beneficiaryCheckbox.change(function () {
                beneficiarySection.toggle($(this).val());
            });

            // Toggle the salary change section if corresponding toggle is clicked
            salaryChangeCheckbox.change(function () {
                var isChecked = $(this).is(':checked');

                salaryChangeSection.toggle(isChecked);

                if (isChecked) {
                    if (salaryIncreaseContainer.children('.salary-increase-row').length === 0) {
                        addSalaryIncrease.click();
                    }
                }
                else {
                    clearAllSalaryIncreases();
                }
            });

            // Toggle the purchase estimate section details if corresponding toggle is clicked
            purchaseEstimatesSwitch.change(function () {
                var isChecked = $(this).is(':checked');

                purchaseEstimatesSectionDetails.toggle($(this).val());
                clearAllSelectedPurchases();

                if (isChecked) {
                    salaryChangeCheckbox.prop('checked', false);
                    salaryChangeSection.toggle(false);
                    salaryChangeCheckbox.setDisabled(true);
                    clearAllSalaryIncreases();
                }
                else {
                    salaryChangeCheckbox.setDisabled(false);
                }
                
            });

            // Call functions to enable/disable a selected SPC and default the dates
            selectedPurchaseEstimateCheckbox.change(function () {
                toggleSelectedPurchase($(this))
                setDefaultDates()
            });

            // Update BackDROP Date when needed
            benefitEffectiveDate.change(_addBackDropMonths);
            benefitEffectiveDateHidden.change(_addBackDropMonths);
            backDropMonths.change(_addBackDropMonths);

            // Get drop plan select helper and bind event to refresh the options
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            dropEntryDate.change(_.debounce(_updateDropPlanSelect, 500));

            separationDate.change(_.debounce(_toggleBackDROPVisibility, 500));

            // Add salary increase button
            addSalaryIncrease.click(addSalaryIncreaseRow);

            // Remove salary increase button
            salaryIncreaseContainer.on('click', '.remove-salary-increase', function () {
                $(this).closest('.salary-increase-row').remove();
            });

            // Update BED and backDropDate when separation date is changed
            function _handleSeparationDateChange() {

                try {
                var newDate = new Date($(separationDate).val());
                newDate = endOfNextMonth(newDate);
                benefitEffectiveDate.val(newDate);
                benefitEffectiveDateHidden.val(newDate);

                    // Adjust backDropDate if needed
                    if (backDropCheckbox.val()) {
                        _addBackDropMonths();
                    }
                }
                catch { }
            }

            // Update BED based on the number of backDrop months
            function _addBackDropMonths() {

                var benefitEstimateDate = new Date($(benefitEffectiveDate).val());
                var isoDate = new Date(benefitEstimateDate.toISODateString());

                // Account for time zones so our BackDROP Date doesn't get the wrong day
                isoDate = new Date(isoDate.getTime() - isoDate.getTimezoneOffset() * -60000);
                isoDate.setMonth(isoDate.getMonth() - backDropMonths.val())

                var newDateStr = isoDate.toISODateString().split("-")
                backDropDate.html(`${newDateStr[1]}/${newDateStr[2]}/${newDateStr[0]}`);
            }

            // Update the drop plan select options based on new dropEntryDate
            function _updateDropPlanSelect() {

                dropPlanSelectHelper.loadOptionsFrom(backendUrls.getAvailableDropPlans,
                    { fundKey: fundKey.val(), dropPlanEntryDate: dropEntryDate.val() },
                    { withBlank: true, maintainSelection: true },
                    function () {
                        if (this.getOptions().length > 0) {
                            eventBanner.removeErrorMessages();
                        }
                    }
                );
            }

            function _toggleBackDROPVisibility() {
                if (benefitEffectiveDate.val() != null) {

                    // Make AJAX call to toggle visibility of the backDROP section the estimate
                    $.getJSON(
                        backendUrls.getRetroDROPEligible,
                        { fundKey: fundKey.val(), benefitEffectiveDate: benefitEffectiveDate.val() }
                    ).always(function (data) {
                        if (data.retroDROPEligibleFlag) {
                            backDropSection.toggle(true);
                        }
                        else {
                            backDropSection.toggle(false);
                        }
                    });
                }
                else {
                    backDropSection.toggle(false);
                }
            }

            // Enable/Disable single toggled SPC row
            function toggleSelectedPurchase(row) {
                var spc = row.closest('tr');

                if (row.is(':checked')) {
                    spc.addClass('selected-row');
                } else {
                    spc.removeClass('selected-row');
                    separationDate.setDisabled(false);
                }
            }

            // Clears all the selected SPC rows and enables separation date
            function clearAllSelectedPurchases() {
                selectedPurchaseEstimateCheckbox.prop('checked', false);
                selectedPurchaseEstimateCheckbox.closest('tr').removeClass('selected-row');
                separationDate.setDisabled(false);
            }

            // Defaults separation and benefit effective dates based on selected SPCs
            function setDefaultDates() {
                var earliestSeparationDate = null;
                var earliestBenEffDate = null;

                selectedPurchaseEstimateCheckbox.each(function (index) {

                    if ($(this).is(':checked')) {
                        var separationDate = $(selectedPurchaseEstimateRetirementDate[index]).val();
                        var benEffDate = $(selectedPurchaseEstimateAnnuityDate[index]).val();

                        if (separationDate) {
                            var parsed = new Date(separationDate);
                            if (!isNaN(parsed)) {
                                if (earliestSeparationDate === null || parsed < earliestSeparationDate) {
                                    earliestSeparationDate = parsed;
                                }
                            }
                        }

                        if (benEffDate) {
                            var parsed = new Date(benEffDate);
                            if (!isNaN(parsed)) {
                                if (earliestBenEffDate === null || parsed < earliestBenEffDate) {
                                    earliestBenEffDate = parsed;
                                }
                            }
                        }
                    }
                });

                // If we found an earlier Separation Date set the value and disable separation date
                if (earliestSeparationDate !== null) {
                    separationDate.val(earliestSeparationDate.toISODateString());
                    separationDateHidden.val(earliestSeparationDate.toISODateString());
                    separationDate.setDisabled(true);
                }

                // If we found an earlier Benefit Effective Date, set the value
                if (earliestBenEffDate !== null) {
                    benefitEffectiveDate.val(earliestBenEffDate.toISODateString());
                    benefitEffectiveDateHidden.val(earliestBenEffDate.toISODateString());
                }
            }

            // Returns the date of the last day of the following month
            function endOfNextMonth(date) {
                var d = new Date(date.getUTCFullYear(), date.getUTCMonth() + 2, 0); // day 0 of 2 months from date = last day of next month

                return d.toISODateString();
            }

            // Adds a salary increase row to the form
            function addSalaryIncreaseRow() {
                // Unique key per row (stable even when others are removed)
                var key = Math.random().toString(36).slice(2)
                var newRow = salaryIncreaseTemplate.children().clone();

                // Replace the placeholder in name/id/for and validation target
                newRow.find('[name]').each(function () {
                    var name = this.getAttribute('name');
                    if (name) this.setAttribute('name', name.replace(/__index__/g, key));
                });

                newRow.find('[id]').each(function () {
                    var id = this.getAttribute('id');
                    if (id) this.setAttribute('id', id.replace(/__index__/g, key));
                });

                newRow.find('label[for]').each(function () {
                    var htmlFor = this.getAttribute('for');
                    if (htmlFor) this.setAttribute('for', htmlFor.replace(/__index__/g, key));
                });

                newRow.find('[data-valmsg-for]').each(function () {
                    var valFor = this.getAttribute('data-valmsg-for');
                    if (valFor) this.setAttribute('data-valmsg-for', valFor.replace(/__index__/g, key));
                    if (!this.hasAttribute('data-valmsg-replace')) this.setAttribute('data-valmsg-replace', 'true');
                });

                // Ensure there is exactly one .Index input in the new row
                var $idx = newRow.find('input[name="SalaryIncreases.Index"]');
                if ($idx.length === 0) {
                    // Create it if missing
                    $idx = $('<input type="hidden" name="SalaryIncreases.Index">').val(key);
                    newRow.append($idx);
                } else {
                    $idx.val(key);
                }

                // Re-parse form validation for added elements
                salaryIncreaseContainer.append(newRow);
                newEstimateForm.removeData('validator');
                newEstimateForm.removeData('unobtrusiveValidation');
                $.validator.unobtrusive.parse(newEstimateForm);
            }

            // Clears all salary increases
            function clearAllSalaryIncreases() {
                salaryIncreaseContainer.empty();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);